const _getEdap = () => window.edap || [];

const triggerEdapEvent = (eventName, eventData) => {
    window.edap = _getEdap();
    window.edap.push((edap) => {
        edap.trigger(eventName, eventData);
    });
};

export function emitFocusEvent(prefilledValue) {
    triggerEdapEvent('typeahead.focus', {
        prefilledvalue: prefilledValue
    });
}

export function emitStartEvent(prefilledValue) {
    triggerEdapEvent('typeahead.start', {
        prefilledvalue: prefilledValue
    });
}

/**
 * emitGE()
 * options {mixed} - edap parameters for events
 */
export function emitGE({eventaction, eventlabel = '', eventvalue = ''}) {
    triggerEdapEvent('generic.event', {
        eventcategory: 'typeahead',
        eventaction,
        eventlabel,
        eventvalue
    });
}

/**
 * emitSE()
 * Emits selection event for typeahead
 **/
export function emitSE(selectionData) {
    let eventName = 'typeahead.selection';
    triggerEdapEvent(eventName, selectionData);
}
